export class DateService {
    public static formatIsoString(iso: string | Date, locale: string) {
        const dt = new Intl.DateTimeFormat(locale, {
            dateStyle: "full",
            timeStyle: "long",

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } as any);
        return dt.format(new Date(iso));
    }
    public static formatIsoStringShort(iso: string | Date, locale: string) {
        const dt = new Intl.DateTimeFormat(locale, {
            dateStyle: "short",
            timeStyle: "short",

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } as any);
        return dt.format(new Date(iso));
    }
    public static formatDateTime(date: string, locale: string) {
        const dt = new Intl.DateTimeFormat(locale, {
            dateStyle: "long",
            timeStyle: "long",
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } as any);
        return dt.format(new Date(date));
    }

    public static formatDateForVCalendar(date: Date) {
        return `${date.getFullYear()}-${date.getMonth() +
            1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    }
    public static dateParse(date: Date) {
        const [year, month, day] = date.toString().split("-");
        const [hour, minute] = date
            .toString()
            .split("T")[1]
            .split(":");
        return `${year}-${month}-${day.substr(0, 2)} ${hour}:${minute}`;
    }

    public static addDays(date: Date, days: number) {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    public static dateParseYMD(date: string) {
        const [year, month, day] = date.split("-");
        return `${year}-${month}-${day.substr(0, 2)}`;
    }
}
